import React from "react";
import { FormikProps } from "formik";
import ATMLoadingButton from "src/components/UI/atoms/ATMLoadingButton/ATMLoadingButton";
import ATMTextField from "src/components/UI/atoms/formFields/ATMTextField/ATMTextField";
import { StudentFormValues } from "src/models/Student.mode";

type Props = {
  formikProps: FormikProps<StudentFormValues>;
  onClose: () => void;
  formType: "ADD" | "EDIT";
};

const StudentForm = ({ formikProps, onClose, formType }: Props) => {
  const { values, setFieldValue, isSubmitting, handleBlur } = formikProps;

  return (
    <div className="p-4 flex flex-col gap-6">
      <div className="flex justify-between items-center">
        <div className="text-xl font-medium">
          {formType === "ADD" ? "Add Student" : "Update Student"}
        </div>
        <button type="button" className="hover:bg-hover" onClick={onClose}>
          Cancel
        </button>
      </div>
      <div className="flex flex-col gap-4">
        <div>
          <ATMTextField
            name="name"
            value={values.name}
            required
            onChange={(e) => {
              setFieldValue("name", e.target.value);
            }}
            label="Student Name"
            onBlur={handleBlur}
          />
        </div>

        <div>
          <ATMTextField
            name="mobile"
            value={values.mobile}
            required
            onChange={(e) => {
              setFieldValue("mobile", e.target.value);
            }}
            label="Student Mobile"
            onBlur={handleBlur}
          />
        </div>
      </div>
      <div>
        <ATMLoadingButton isLoading={isSubmitting} type="submit">
          Save
        </ATMLoadingButton>
      </div>
    </div>
  );
};

export default StudentForm;
